import React from 'react';
import { useInView } from 'react-intersection-observer';

import './showByLetterStyles.css';

function ShowTextByLetter(text: string, transitionDelayTime?: number, startsFromIndex = 0) {
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    onChange: (inView, entry) => (inView ? entry.target.classList.add('active') : ''),
  });

  return (
    <span ref={ref} className="animationWrapper">
      {/* eslint-disable-next-line react/no-array-index-key */}
      {text.split('').map((letter, index) => <span key={index} style={{ transitionDelay: `${(startsFromIndex + index) * (transitionDelayTime || 20)}ms` }}>{letter}</span>)}
    </span>
  );
}

export default ShowTextByLetter;
